import React, { useState } from "react";
import axios from 'axios';
import {axiosEH} from '../common/functions'
import fileDownload from 'js-file-download';
import jwtUser from '../../jwtUser';

/* 
*/
export default function Report() {
  // 1. 1st-level vars
  const user = jwtUser(); // get user token
  const [statusMsg, setStatusMsg] = useState('');
  let [inputList, setInputList] = useState([{}]);
  const theaders = Object.keys(inputList[0]);
  const rows = inputList.map(item => Object.values(item));

  const handleStartClick = filename => {
    const url = process.env.REACT_APP_BASEURL + `/userreports/${filename}`;
    axios.get(url, { responseType: 'blob', headers: { 'x-access-token': user['x-access-token'] } })
      .then(res => {  // []
        fileDownload(res.data, filename);
        setStatusMsg(`${filename} downloaded`);
      })
      .catch(err => { 
        setStatusMsg(axiosEH(err)); 
      })
  };

  try {
    function getUserReports() {
      const url = process.env.REACT_APP_BASEURL + '/userreports';
      let tokenExpAt, tokenExpInMM;

      axios.get(url, { headers: { 'x-access-token': user['x-access-token'] } })
        .then(res => {  // []
          if (res.data.length) {
            // 1)

            // 2) ISODate to local
            for (const [i, el] of res.data.entries()) {
              res.data[i].expireAt = getLTime(el.expireAt);
            }
            // 3)
            setInputList([...res.data]);
          } else {
            setStatusMsg("No report file");
          }
        })
        .catch(err => { 
          setStatusMsg(axiosEH(err)); 
        })
    } // end of a()

    React.useEffect(() => {
      getUserReports();
    }, []);   // render once only

    const getLTime = isoDT => { // nw
      const isoDateTime = new Date(isoDT);
      const localDT = isoDateTime.toLocaleDateString() + " " + isoDateTime.toLocaleTimeString();
      return localDT.slice(0, 10);
    };

  }
  catch (err) {
    setStatusMsg(err.message);
  }

  return (
    <section >
      {rows[0].length > 0 && <table id="reports-table">
        <thead>
          <tr>
            {theaders.map(header => <th key={header}>{header}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {row.map((cell, index) => <td key={index}>{cell}</td>)}
              <td ><button className="startButton" onClick={() => handleStartClick(row[0])} >&#8595;</button></td>
            </tr>
          ))}
        </tbody>
      </table>}
      <label className="label has-text-success">{statusMsg}</label>
    </section>
  );
}